import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// Epic #443 — Sales→Inventory valuation snapshot (Tier 2 layer).
//
// The companion baseline migration `drizzle/tenant/0028_inventory_valuation_cogs.sql`
// owns the Tier 0/1 changes (accounting_items.average_cost +
// core_companies.{allow_negative_stock, default_cogs_account_id,
// default_inventory_account_id}). This file owns ONLY the inventory module's
// own table, since baseline migrations run BEFORE module migrations create
// the Tier 2 tables — referencing `inventory_stock_entries` from baseline
// would crash a fresh tenant on signup.
//
// What this migration adds to `inventory_stock_entries`:
//   - valuation_rate / valuation_amount: snapshot the unit cost per movement.
//     Incoming entries (purchase / transfer_in / return) snapshot the rate
//     paid; outgoing entries (sale / transfer_out) snapshot the current
//     Moving Average so COGS posting reads the rate without recomputing.
//   - source: distinguishes "sales_invoice", "credit_note", "pos", "manual",
//     etc. beyond the coarser entry_type field. Free-text — no enum check —
//     so adding new sources doesn't need a schema migration.
//   - reference_doctype: completes the (referenceModule, referenceDoctype,
//     referenceId) triple needed for cross-module idempotency lookups.
//   - se_company_ref_idx: makes the "did the listener already post for this
//     invoice?" probe O(log n) instead of full-table scan.
//
// Idempotency: every statement is `ADD COLUMN` (nullable) or `CREATE INDEX`
// — the runner skips "duplicate column" / "already exists" errors so re-
// running on a tenant that previously got the merged 0028 (during local
// development) is safe.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "002_valuation_snapshot",
  version: "1.1.0",
  sql: `
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_rate\` real;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_amount\` real;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`source\` text;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`reference_doctype\` text;
    UPDATE \`inventory_stock_entries\` SET \`valuation_rate\` = \`rate\` WHERE \`valuation_rate\` IS NULL;
    UPDATE \`inventory_stock_entries\` SET \`valuation_amount\` = \`amount\` WHERE \`valuation_amount\` IS NULL;
    CREATE INDEX \`se_company_ref_idx\` ON \`inventory_stock_entries\` (\`company_id\`,\`reference_module\`,\`reference_doctype\`,\`reference_id\`);
  `,
};
